import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-0"}],["path",{"d":"M9 14h6a3 3 0 0 1 -6 0z","key":"svg-1"}],["path",{"d":"M9 8l6 3","key":"svg-2"}],["path",{"d":"M9 11l6 -3","key":"svg-3"}]]

const IconMoodXd = createReactComponent('outline', 'mood-xd', 'MoodXd', __iconNode);

export default IconMoodXd;